if not App.angularApp?
    return

App.angularApp.directive 'mfCustomDataMapDownloadFixedTableHeader', ['$timeout', '$window', ($timeout, $window) ->
    return {
        restrict: 'A',
        link: ($scope, $elem, $attrs, $ctrl) =>

            debug = false

            # wait for content to load into table
            fixIt = () =>
                # reset display styles so column widths are correct when measured below
                $elem.find('thead, tbody').css('display', '')

                # wrap in $timeout to give table a chance to finish rendering
                $timeout () =>
                    # set widths of columns
                    $elem.find('th').each (i, thElem) =>
                        thElem = $(thElem)
                        tdElems = $elem.find('tbody tr:first td:nth-child(' + (i + 1) + ')')

                        console.log thElem if debug
                        console.log tdElems if debug

                        columnWidth = tdElems.width()
                        thElem.width(columnWidth)
                        tdElems.width(columnWidth)

                        console.log columnWidth if debug


                    # set css styles on thead and tbody
                    $elem.find('thead').css
                        display: 'block'

                    $elem.find('tbody').css
                        display: 'block'
                        overflow: 'auto'

                    if $scope.tableHeight
                        $elem.find('tbody').css
                            height: $scope.tableHeight

            # Obviously, fix the table sizing if the window is resized
            angular.element($window).bind 'resize', debounce(() =>
                fixIt()
            )

            # this watcher was causing compounded results b/c the digest runs multiple times
            # now we only call fixIt if the visiblity has changed
            @previouslyVisible = $elem.find('tbody').is(':visible')
            $scope.$watch(
                () =>
                    return $elem.find('tbody').is(':visible') isnt @previouslyVisible
                , (resize) =>
                    if resize
                        @previouslyVisible = $elem.find('tbody').is(':visible')
                        fixIt()
            )

            # FIXME: OH MY GOSH KILL ME NOW
            if $attrs.mfFixedHeaderUnholyMapHack?
                handle = debounce(() ->
                    fixIt()
                    $timeout fixIt, 100
                , 800)
                App.map.on 'resize', handle
                $scope.$on '$destroy', () ->
                    App.map.off('handle', handle)

            if $attrs?.mfCustomDataMapDownloadFixedTableHeader
                $scope.$watch($attrs.mfCustomDataMapDownloadFixedTableHeader, fixIt)
    }
]
